import { Component, OnInit, ViewChild, OnDestroy, NgZone, HostListener, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, FormBuilder } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { DatePipe, Location } from '@angular/common';
import { Product } from 'src/app/models/product';
import { Constant } from 'src/app/constant/constant';
import { CategoryService } from 'src/app/services/category.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FieldConfig } from 'src/app/shared/dynamic-form/field-interface';
import { CalsoftAuditComponent } from 'src/app/pages/audit/audit.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, takeUntil } from 'rxjs/operators';
import { ScrollbarComponent } from 'src/app/shared/scrollbar/scrollbar.component';
import { ScreenSizeService } from 'src/app/services/screen-size.service';
import { AttributesetService } from 'src/app/services/attributeset.service';
import { environment } from 'src/environments/environment';
import { ConfigService } from 'src/app/services/config.service';
import { WebsocketService } from 'src/app/services/websocket.service';
import { OrderReceivedPopupComponent } from 'src/app/shared/order-received-popup/order-received-popup.component';
import { DealsEntityService } from 'src/app/services/deals-entity.service';
import { DealsService } from 'src/app/services/deals.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { LoaderService } from 'src/app/services/loader.service';
@UntilDestroy()

@Component({
  selector: 'calsoft-add-editdeals',
  templateUrl: './add-editdeals.component.html',
  styleUrls: ['./add-editdeals.component.scss']
})
export class AddEditdealsComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  @Input() type: any = 1;

  @Input() leadId: any = 0;

  protected _onDestroy = new Subject<void>();
  b2bPricingEnabled: any = false;
  row: any;
  dealId: any;
  visible: boolean;
  dealAdd: any;
  description: boolean;
  attributeSetIdList: Object;
  defaultValue: any;
  defalutValue: any;
  group: UntypedFormGroup;
  attributeGroup: any;
  groupName: any;
  selection: any = [];
  entityValue: any;
  activeGroup: string;
  activeType: string;
  showOnlyStarred: boolean;
  text: any;
  activeGroupSubscription: Subscription;
  attributeFilterControl: UntypedFormControl = new UntypedFormControl();
  public serverPath8 = environment.commonImageApi;

  clickListeners: Function[] = [];

  respondActive: boolean;


  regConfig: FieldConfig[]

  selectedIndex = 0;
  lastIndex = 3;
  operationType: string;
  title: string;
  attributeSetList: any;


  //new
  drawerOpen = true;
  drawerMode = 'side';
  drawerDisableClose = true;
  form: UntypedFormGroup;
  invalidMap = new Map<any, any>();
  ValidMap = new Map<any, any>();
  fieldValue: any[];
  series: any = [];
  validations: any = [];
  valueId: any;
  empty: string;
  list: any;
  productEntity: any;
  dealsEntityVarchar: any = [];
  dealsEntityInt: any = [];
  dealsEntityText: any = [];
  dealsEntityDecimal: any = [];
  dealsEntityStatic: any = [];
  dealsEntityDatetime: any = [];
  imagesToRemoved: any = [];
  mediaGallery: any = [];
  textAdd: string;
  auditData: Object;
  auditType: any;
  filteredAttributeList: any;
  filteredAttributeTypeList: any;
  options: any;
  sameDealName: boolean;
  visibleConfig: boolean = false;

  emailValue: any;
  phoneValue: any;
  productConfigurable: boolean;
  relatedProductList: any = [];

  productSuperLinkList: any = [];
  upSellsProductList: any = [];
  crossSellsProductList: any = [];
  productLinkList: any = [];
  relatedProducts: any = [];
  upSellsProduct: any = [];
  crossSellsProduct: any = [];
  productData: any;
  updateStockByPurchaseOnly: any = false;
  variants1: any = [];
  variants2: any = [];
  variantsList: any = [];
  DealVariant: boolean = false;
  currentIndex: any;
  data: Object;
  initalSelectionList: any = [];
  bookingEnabled: boolean = false;
  productRestriction: boolean = false;
  textAccount: string;
  orginalData: any;
  leadDisplay: boolean = true;
  init: boolean = false;
  emailRequired: any;
  companyRequired: any;




  previousPage() {
    this.selectedIndex -= 1;
  }

  nextPage() {
    this.selectedIndex += 1;
  }
  firstFormGroup: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private ecryptService: EcryptServiceService,
    public loc: Location,
    private route: ActivatedRoute,
    private attributeService: AttributesetService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private commonService: CommonService,
    private cd: ChangeDetectorRef,
    private screenSizeService: ScreenSizeService,
    private mediaMatcher: MediaMatcher,
    private datepipe: DatePipe,
    private configService: ConfigService,
    private _formBuilder: FormBuilder,
    private dealService: DealsService,
    private dealsEntityService: DealsEntityService,
    public websocket: WebsocketService,
    private loaderService: LoaderService
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    //this.initWebsocket();
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }

  mobileQuery = this.mediaMatcher.matchMedia('(max-width: 959px)');
  drawerOpen$ = this.screenSizeService.drawerOpen$;
  public serverPath = environment.ImageAPI;
  public serverPath1 = environment.ImageAPI1;
  public serverPath2 = environment.thumnail;
  public serverPath7 = environment.commonImageApi + "catalog/product";
  public serverPath3 = environment.ImageAPI2

  public serverPath4 = environment.commonImageApiNew

  productType: any = [
    "simple", "Configurable", "Variants", "Booking", "Subscription"
  ]

  productType1: any = [
    "simple"
  ]


  createAttributeForm() {
    this.firstFormGroup = this.formBuilder.group({
      attributeSet: ['', Validators.required],
      type: [''],
    });
  }

  createAttributeValidations = {
    'attributeSet': [
      { type: 'required', message: 'Please fill out this field.' },
    ],
    'type': [
      { type: 'required', message: 'Please fill out this field.' },
    ],

  }

  private _mobileQueryListener: () => void;

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
      this._onDestroy.next();
      this._onDestroy.complete();
  }



  ngOnInit() {

    this.loaderService.show();
    this.getResource();
    this.textAccount = 'OK';

    console.log(this.leadId);


    if (this.router.url.includes("/duplicateDeal")) {
      this.dealId = 0;

    } else {

      this.dealId = this.route.snapshot.params['dealId'];
    }

    this.createAttributeForm();
    this.attributeSetFilter();


    if (this.route.snapshot.params['leadId'] != undefined) {

      this.leadId = this.route.snapshot.params['leadId'];

      this.firstFormGroup.value.entityId = this.leadId;

      this.leadDisplay = false;

    }

  }


  productLimitedRestrictionValue: any;
  productLimitedRestriction: boolean = false;

  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.DEALS)
      .subscribe((data: any) => {



        if ((this.dealId == 0 && !data.create) || (this.dealId != 0 && !data.update)) {

          this.router.navigate(['/unauthorized'])
        } else {

          this.getConfigData();

          this.productLimitedRestriction = false;

          this.defalutValue = 0;

          this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
          this._mobileQueryListener = () => {
            this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
            this.cd.detectChanges();
          };
          this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            filter(() => this.mobileQuery.matches),
            untilDestroyed(this)
          ).subscribe(() => this.closeDrawer());

          this.visible = false;
          this.text = "Save";
          this.textAdd = "Create"

              if (this.router.url.includes("/duplicateproduct")) {
            this.dealAdd = true;
            this.title = 'Add Deals'
            this.firstFormGroup.value.type = "ss";
            this.firstFormGroup.value.attributeSet = this.route.snapshot.params['setId'];
            this.operationType = 'Change'
            this.getAttributeGroup();
          }
      

          else if (this.dealId == 0) {
            this.dealAdd = true;
            this.operationType = 'New'
            this.title = 'Add Deals'
            this.firstFormGroup.value.attributeSet = this.route.snapshot.params['setId'];
            this.getAttributeGroup();
            this.init = true;
          }

          else if (this.dealId > 0) {
            this.title = 'Edit Deals'
            this.firstFormGroup.value.type = "ss";
            this.firstFormGroup.value.attributeSet = this.route.snapshot.params['setId'];
            this.operationType = 'Change'
            this.getAttributeGroup();
            this.init = true;
          }


        }
      })
  }




  audit(i) {

    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(CalsoftAuditComponent, {
        width: '900px',
        disableClose: true,
        data: { page: i, }
      });
      dialogRef.disableClose = false;
      dialogRef.afterClosed().subscribe(result => {

      });
    }
    else {
      let dialogRef = this.dialog.open(CalsoftAuditComponent, {
        minWidth: '100vw', height: '100vh',
        data: { page: i, }
      });
      dialogRef.disableClose = false;
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }




  back() {
    this.loc.back();
  }




  getAttributeGroup() {

    if ((this.text == 'Save' || this.textAdd == 'Create')) {
      this.textAdd = "Processing"
      this.entityValue = {
        "typeId": this.firstFormGroup.value.type,
        "attributeSetId": this.firstFormGroup.value.attributeSet,

      }
      this.attributeService.getattributeSetId(this.firstFormGroup.value.attributeSet).subscribe(
        attributesets => {
          
          this.attributeSetIdList = attributesets['data']
          this.attributeGroup = attributesets['data']['eavAttributeGroup']
          this.dealAdd = true;
          this.regConfig = this.attributeSetIdList['eavAttributeGroup']

          this.groupName = this.regConfig[this.defalutValue]['attributeGroupName']
          this.form = this.createControl();


          if (this.router.url.includes("/duplicateproduct")) {
            this.getDealById(this.route.snapshot.params['dealId']);
          }

          else if (this.dealId > 0) {
            this.getDealById(this.dealId);
          }

          this.loaderService.hide();

          this.textAdd = "Create";
        },
        error => {
          this.textAdd = "Create";
        }
      )
    }
    else {
      this.textAdd = "Create";
      this.validateAllFormFields(this.firstFormGroup)
    }

  }




  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }


  booleanField: any = [
    { "value": 1, "viewValue": "Yes" },
    { "value": 0, "viewValue": "No" },
  ]



  getAttributeSetDropDown() {
    this.attributeService.getAttributeSetDropDownList(11).subscribe(
      res => {
        this.attributeSetList = res;

        this.filteredAttributeList = this.attributeSetList;

      },
      error => {

      }
    )
  }





  //create controls
  createControl() {
    let group;
    group = this.formBuilder.group({});



    let i = 0;
    this.regConfig.forEach(element => {


      if (element.attributeGroupId != 0) {

        element['eavEntityAttribute'].forEach(field => {

          if (field.eavAttribute.attributeCode != "special_from_date" || field.eavAttribute.attributeCode != "special_to_date") {



            this.fieldValue = field;
            if (field.eavAttribute.frontendLabel != null &&
              field.eavAttribute.frontendLabel != undefined && field.eavAttribute.frontendInput != null) {

              if (field.eavAttribute['isVisible'] == 1) {
                field.eavAttribute['validations'] = [];
                field.eavAttribute['validations'] = [];
                let val = {
                  name: "required",
                  validator: Validators.required,
                  message: " Please fill out this field.",
                }
                if (field.eavAttribute.isRequired == 1) {

                  if (this.invalidMap.get(i) == undefined) {
                    let val =
                      '(' + 'this.' + 'form' + '.controls' + "['" + field.eavAttribute.attributeCode.toString() + "']" + '.status' + "=='INVALID'"

                    this.invalidMap.set(i, val);
                    this.ValidMap.set(i, val);
                  } else {
                    if (field.eavAttribute.attributeCode != null) {
                      let val = '||' + 'this.' + 'form' + '.controls' + "['" + field.eavAttribute.attributeCode.toString() + "']" + '.status' + "=='INVALID'"

                      let inval = '&&' + 'form' + '.controls' + "['" + field.eavAttribute.attributeCode.toString() + "']" + '.status' + "=='VALID'"
                      this.invalidMap.set(i, this.invalidMap.get(i) + val);
                      this.ValidMap.set(i, this.ValidMap.get(i) + inval);
                    }
                  }
                  // this.map.set(i,field.eavAttribute.frontendLabel);
                  field.eavAttribute['validations'].push(val);
                  this.validations.push(val);

                }
                if (field.eavAttribute.frontendClass == 2) {
                  let emailval = {
                    name: "pattern",
                    validator: Validators.pattern(
                      "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$"
                    ),
                    message: "Invalid email"
                  }
                  field.eavAttribute['validations'].push(emailval);
                  this.validations.push(emailval);
                }
                else if (field.eavAttribute.frontendClass == 1 || field.eavAttribute.frontendClass == 3) {
                  let numberval = {
                    name: "pattern",
                    validator: Validators.pattern(/^-?(0|[1-9]\d*)?$/),
                    message: "Only Numbers"
                  }
                  field.eavAttribute['validations'].push(numberval);
                  this.validations.push(numberval);
                }
                else if (field.eavAttribute.frontendClass == 5) {
                  let numberval = {
                    name: "pattern",
                    validator: Validators.pattern('^[a-zA-Z \-\']+'),
                    // validator: Validators.pattern('^[a-zA-Z][\sa-zA-Z]*'),
                    message: "Only  Alphabets"
                  }
                  field.eavAttribute['validations'].push(numberval);
                  this.validations.push(numberval);
                }
              }



              this.series.push({
                attributeId: field.eavAttribute.attributeId,
                entityTypeId: field.eavAttribute.entityTypeId,
                attributeCode: field.eavAttribute.attributeCode,
                backendType: field.eavAttribute.backendType,
                frontendInput: field.eavAttribute.frontendInput,
              })
              const control = this.formBuilder.control(
                field.eavAttribute.value,
                this.bindValidations(field.eavAttribute.validations || [])
              );
              group.addControl(field.eavAttribute.attributeCode, control);
              //group.controls[field.eavAttribute.attributeCode].setValue(0);

              if (field.eavAttribute.backendType == 'int' && field.eavAttribute.defaultValue != null && field.eavAttribute.defaultValue.length > 0) {
                group.controls[field.eavAttribute.attributeCode].setValue(parseInt(field.eavAttribute.defaultValue), { onlySelf: true });
              }
              else if ((field.eavAttribute.backendType == 'varchar' || field.eavAttribute.backendType == 'text') && field.eavAttribute.defaultValue != null && field.eavAttribute.defaultValue.length > 0) {
                group.controls[field.eavAttribute.attributeCode].setValue(field.eavAttribute.defaultValue, { onlySelf: true });
              }
              // else if (field.eavAttribute.backendType == 'datetime' && field.eavAttribute.defaultValue != null && field.eavAttribute.defaultValue.length > 0) {
              //   group.controls[field.eavAttribute.attributeCode].setValue(new Date(field.eavAttribute.defaultValue), { onlySelf: true });
              // }
            }
          }
        });
        if (this.invalidMap.get(i) != undefined) {
          let finaloutputInValid = this.invalidMap.get(i) + ')';
          this.invalidMap.set(i, finaloutputInValid);
          let finaloutputValid = this.ValidMap.get(i) + ')';
          this.ValidMap.set(i, finaloutputValid);
        }
        i++;
      }
    });


    return group;
  }



  bindValidations(validations: any) {
    if (validations.length > 0) {
      const validList = [];
      validations.forEach(valid => {
        validList.push(valid.validator);
      });
      return Validators.compose(validList);
    }
    return null;
  }

  //edit a Categor
  getDealById(entityId: number) {
    this.dealsEntityService.getDealsById(entityId)
      .subscribe(
        (product: Product) =>
          this.editProduct(product),
        (err: any) => { }
      );

  }

  listOfOptions: any = [];

  editProduct(product: Product) {

    this.productData = product;
    this.firstFormGroup.value.typeId = product.typeId;
    let products = product.values;
    this.phoneValue = product['values']['PhoneNumber'];
    this.emailValue = product['values']['Email'];
    this.orginalData = product['values']['originalData'];
    this.valueId = product.valueIds;
    this.series.forEach(element => {
      let attributeCode = element.attributeCode

      if (element.frontendInput == 'multiselect' && products[attributeCode] != null) {

        let listOfOptions: any = [];
        products[attributeCode].split(',').forEach(element => {
          listOfOptions.push(parseInt(element))
        });
        this.form.patchValue({
          [attributeCode]: listOfOptions
        });
      }
      else if (element.backendType == 'datetime') {
        if (products[attributeCode] != undefined && products[attributeCode] != null && products[attributeCode] !== '') {
          let str = (products[attributeCode] + '').trim();
          if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
            str += 'T00:00:00';
          } else if (/^\d{4}-\d{2}-\d{2}[ T]05:30:00(\.000)?$/.test(str)) {
            str = str.substring(0, 10) + 'T00:00:00';
          } else if (str.includes(' ') && !str.includes('T')) {
            str = str.replace(' ', 'T');
          }
          const d = new Date(str);
          this.form.patchValue({
            [attributeCode]: !isNaN(d.getTime()) ? d : products[attributeCode],
          });
        }
      } else {
        this.form.patchValue({
          [attributeCode]: products[attributeCode]
        });
      }
    });


  }


  public toggleMenuItem(menuId) {
    let menuItem = document.getElementById('menu-item-' + menuId);
    let subMenu = document.getElementById('sub-menu-' + menuId);
    if (subMenu) {
      if (subMenu.classList.contains('show')) {
        subMenu.classList.remove('show');
        menuItem.classList.remove('expanded');
      }
      else {
        subMenu.classList.add('show');
        menuItem.classList.add('expanded');
      }
    }
  }




  saveDeal() {

    if (this.form.valid && this.sameDealName) {


      let dealsEntity = {

        dealsVarchar: [],
        dealsInt: [],
        dealsText: [],
        dealsDecimal: [],
        dealsDateTime: [],


      }

      for (let i = 0; i < this.series.length; i++) {

        this.series[i].value = this.form.value[this.series[i].attributeCode];
        if (this.dealId > 0) {
          this.series[i].entityId = this.dealId;
          this.series[i].valueId = parseInt(this.valueId[this.series[i].attributeCode]);
        }
        this.series[i].storeId = 1;
        if (this.series[i].backendType == "varchar" && this.series[i].value != null && this.series[i].frontendInput == "multiselect" && this.series[i]) {
          this.series[i].entityId = this.dealId;
          if (Array.isArray(this.series[i].value)) {
            this.series[i].value = this.series[i].value.join(',');
          } else {
            this.series[i].value = this.series[i].value.toString();
          }
          dealsEntity.dealsVarchar.push(this.series[i]);
        }
        else if (this.series[i].backendType == "varchar" && this.series[i]) {
          this.series[i].entityId = this.dealId;
          if (Array.isArray(this.series[i].value)) {
            this.series[i].value = this.series[i].value.join(',');
          }
          dealsEntity.dealsVarchar.push(this.series[i]);
        } else if (this.series[i].backendType == "int") {
          this.series[i].entityId = this.dealId;
          let val = this.series[i].value;
          if (Array.isArray(val)) {
            let firstVal = val.length > 0 ? val[0] : null;
            let numVal = parseInt(firstVal, 10);
            this.series[i].value = !isNaN(numVal) ? numVal : null;
          } else if (typeof val === 'string' && val.includes(',')) {
            let firstVal = val.split(',')[0].trim();
            let numVal = parseInt(firstVal, 10);
            this.series[i].value = !isNaN(numVal) ? numVal : null;
          }
          dealsEntity.dealsInt.push(this.series[i]);
        }
        else if (this.series[i].backendType == "text") {
          this.series[i].entityId = this.dealId;
          dealsEntity.dealsText.push(this.series[i])
        } else if (this.series[i].backendType == "decimal") {

          if (this.series[i].value == null) {
            this.series[i].entityId = this.dealId;
            this.series[i].value = 0.0;
            this.series[i].value = parseFloat(this.series[i].value)
          }
          dealsEntity.dealsDecimal.push(this.series[i])
        }
        else if (this.series[i].backendType == "datetime") {
          if (this.series[i].value != null && this.series[i].value !== '') {
            this.series[i].entityId = this.dealId;
            let val = this.series[i].value;
            let d: Date = null;
            if (val instanceof Date) {
              d = new Date(val.getTime());
            } else if (typeof val === 'string') {
              let str = val.trim();
              if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
                str += 'T00:00:00';
              } else if (/^\d{4}-\d{2}-\d{2}[ T]05:30:00(\.000)?$/.test(str)) {
                str = str.substring(0, 10) + 'T00:00:00';
              } else if (str.includes(' ') && !str.includes('T')) {
                str = str.replace(' ', 'T');
              }
              d = new Date(str);
            } else {
              d = new Date(val);
            }
            if (d && !isNaN(d.getTime())) {
              if (d.getHours() === 5 && d.getMinutes() === 30 && d.getSeconds() === 0) {
                d.setHours(0, 0, 0, 0);
              }
              const formattedDate = this.datepipe.transform(d, "yyyy-MM-dd'T'HH:mm:ss");
              this.series[i].value = formattedDate;
            }
            dealsEntity.dealsDateTime.push(this.series[i]);
          }
        }

      }

      dealsEntity['operationType'] = this.dealId == 0 ? "NEW" : "CHANGE";
      dealsEntity['entityTypeId'] = 11;
      dealsEntity['attributeSetId'] = this.entityValue.attributeSetId;
      dealsEntity['typeId'] = this.dealId == 0 ? this.entityValue.typeId : this.firstFormGroup.value.typeId;
      dealsEntity['hasOptions'] = 4;

      dealsEntity['leadSourceId'] = this.form.value.LeadSource;

      dealsEntity['leadStatusId'] = this.form.value.Stage;

      dealsEntity['probability'] = this.form.value.Probability;

      dealsEntity['revenue'] = this.form.value.ExpectedRevenue;

      dealsEntity['closingDate'] = this.form.value.ClosingDate;

      dealsEntity['leadId'] = this.form.value.LeadId;

      dealsEntity['companyId'] = this.form.value.CompanyId;

      dealsEntity['amount'] = this.form.value.Amount;

      dealsEntity['balance'] = this.form.value.Balance;

      dealsEntity['paid'] = this.form.value.Paid;

      if (this.orginalData != undefined) {
        if (this.orginalData != null) {
          dealsEntity['originalData'] = this.orginalData;
        }
      }

      if (this.dealId > 0) {
        dealsEntity['entityId'] = this.dealId;

      }
      this.dealsEntityService.addDeals(dealsEntity).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {


            if (this.leadDisplay) {
              this.router.navigate(['/deals']);
            } else if (this.router.url.includes("add-edit-deals-company")) {
              this.router.navigate([`companiesDetail/${this.leadId}`])
            }
            else {
              this.router.navigate([`leadDetail/${this.leadId}`])
            }

            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            this.text = "Save"
            // if (response['data']['operationType'] == 'NEW') {
            //   const userId = parseInt(response['data']['ownerId']);      
            //   this.initWebsocket(userId);
            // }
          }

          else {
            this.text = "Save"
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }

        },
        (err) => { this.text = "Save" });
    } else {
      this.text = "Save"
      this.validateAllFormFields(this.form);
    }
  }
  checkDealExist() {
    console.log(this.form);

    let payload = {
      "DealName": this.form.value.DealName,
      "AccountName": this.form.value.AccountName,

    }
    this.dealsEntityService.dealsAlreadyExist(payload).subscribe(
      (response) => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.sameDealName = true;
          this.clearValue();
          this.saveDeal();
        }
        else {
          this.text = "Save"
          this.snackBar.open(response['data']['message'], '×',
            { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
        this.text = "Save"
        this.sameDealName = true
      });

    return this.sameDealName;
  }

  clearValue() {

    let url = "/deals";
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");
    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    localStorage.removeItem("advanceFilterConditions");

  }




  check() {
    if (this.dealId != 0) {
      this.firstFormGroup.value.operationType = "Change"
    }
    else {
      this.firstFormGroup.value.operationType = "New"
    }
    if (this.form.valid) {

      if (this.dealId == 0) {
        this.checkDealExist();
        this.sameDealName = false;
      }
      // this.phoneValue = product['values']['PhoneNumber'];
      // this.emailValue = product['values']['Email'];
      else if (this.dealId > 0 && (this.emailValue != this.form.value.Email
        || this.phoneValue != this.form.value.PhoneNumber)) {
        this.checkDealExist();
        this.sameDealName = false;
      }
      else {
        this.sameDealName = true;
        this.saveDeal();
      }

    }


  }
  save() {

    this.text = "Processing"
    if (this.dealId != 0) {
      this.firstFormGroup.value.operationType = "Change"
    }
    else {
      this.firstFormGroup.value.operationType = "New"
    }
    if (this.form.valid) {
      this.sameDealName = true
      this.check()

    } else {
      this.text = "Save"
      this.validateAllFormFields(this.form);
    }
  }



  checkValidataion(i) {

    return eval(this.invalidMap.get(i));

  }

  drawerChange(drawerOpen: boolean) {
    this.screenSizeService.drawerOpen.next(drawerOpen);
  }

  openDrawer() {
    this.screenSizeService.drawerOpen.next(true);
    this.cd.markForCheck();
  }

  closeDrawer() {
    this.screenSizeService.drawerOpen.next(false);
    this.cd.markForCheck();
  }

  @ViewChild(ScrollbarComponent, { static: true }) scrollbar: ScrollbarComponent;
  public tabsContentRef!: ScrollbarComponent;
  scrollToBottom() {
    this.tabsContentRef.scrollbarRef.getScrollElement().scrollTo({
      behavior: 'smooth',
      top: 0
    });

  }

  onActivate() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  duplicate() {

    this.router.navigate([`product/duplicateproduct/${this.dealId}/${this.route.snapshot.params['setId']}`])
  }


  attributeSetFilter() {
    this.attributeFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.attributeFilter();
      });
  }


  protected attributeFilter() {
    if (!this.attributeSetList) {
      return;
    }
    // get the search keyword
    let search = this.attributeFilterControl.value;
    if (!search) {
      this.filteredAttributeList = this.attributeSetList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredAttributeList = this.attributeSetList.filter(attributeSetName => attributeSetName['attributeSetName'].toLowerCase().indexOf(search) > -1)
  }

  _keyPress(event: any) {
    const pattern = /[^0-9.]*/;
    let inputChar = String.fromCharCode(event.charCode).trim();

    if (!pattern.test(inputChar)) {
      event.preventDefault();
    } else if (inputChar.length == 0) {
      event.preventDefault();
    }

  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.openDrawer()
  }




defaultDealsSet: any = 0;

  getConfigData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);
        localStorage.setItem("value", JSON.stringify(data))
        this.data = data;

        this.defaultDealsSet = data['defaultDealsSet'];

        this.emailRequired = data['leadEmail'] || 0;
        this.companyRequired = data['companiesEmail'] || 0;

      }

      catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }


  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Backspace') {
      event.preventDefault();
    }
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;


  }

  get(i, j, k) {

    this.defalutValue = '';
    this.groupName = i;
    this.defalutValue = j;


    this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
    this.scrollToBottom();
  }

  orderConfirmPopup() {
    let dialogRef = this.dialog.open(OrderReceivedPopupComponent, {
      width: '250px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
    const audio = new Audio();
    audio.src = 'assets/order-voice/Deal.mp3';
    audio.load();
    audio.play();
  }






  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}
